import React from 'react';
import Select, { type SelectProps } from '@atlaskit/select';

export const FormSelect = <T extends object, IsMulti extends boolean = false>(
	props: SelectProps<T, IsMulti>,
): React.JSX.Element => (
	<Select<T, IsMulti>
		styles={{
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			menuPortal: (base: any) => ({
				...base,
				zIndex: 9999,
			}),
		}}
		menuPortalTarget={globalThis.document.body}
		{...props}
	/>
);
